/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Actualize settings.
 */
export interface ActualizeSettingsLastmile { 
    /**
     * Departure date and time according to the [RFC 3339, section 5.6 (ISO8601)](https://tools.ietf.org/html/rfc3339#section-5.6).
     */
    current_time?: string;
    /**
     * Time zone for calculation results.
     */
    result_timezone?: number;
    /**
     * Geodata provider.
     */
    geo_provider?: string;
    /**
     * Use toll roads.
     */
    toll_roads?: boolean;
    /**
     * Use ferry crossing.
     */
    ferry_crossing?: boolean;
}

